
import { defineComponent } from "vue";
import Step from "@/components/Step.vue";
import Button from "primevue/button";
import InputNumber from "primevue/inputnumber";
import { enumerate_climbing_stairs } from "./algorithm";

export default defineComponent({
  name: "App",
  components: {
    Step,
    Button,
    InputNumber,
  },
  data() {
    return {
      requestedNumberOfSteps: this.$store.state.numberOfSteps,
      simulating: false,
    };
  },
  computed: {
    width(): string {
      return `calc(100% / ${this.$store.state.numberOfSteps} - 1px)`;
    },
  },
  methods: {
    async handleStart() {
      this.simulating = true;
      await this.$nextTick(); // ensure the min/max validator to have run
      this.$store.commit("setNumberOfSteps", this.requestedNumberOfSteps);
      for (let seq of enumerate_climbing_stairs(
        this.$store.state.numberOfSteps
      )) {
        this.$store.commit("initCurrentStep");
        for (let idx of seq) {
          await new Promise<void>((res) => setTimeout(() => res(), 200));
          this.$store.commit("decrCurrentStep", idx);
          if (!this.simulating) {
            break;
          }
        }
        if (!this.simulating) {
          break;
        }
      }
      this.simulating = false;
    },
  },
});
